<template>
    <div
        class="message-wrapper"
        :class="messagePosition"
    >
        <div
            v-if="currentConversationType === $TIM_TYPES.CONV_C2C"
            class="c2c-layout"
            :class="messagePosition"
        >
            <div
                v-if="showAvatar"
                class="col-1"
            >
                <!-- 头像 -->
                <avatar :src="avatar" />
            </div>
            <div class="col-2">
                <!-- 消息主体 -->
                <div class="content-wrapper">
                    <message-status-icon
                        v-if="isMine"
                        :message="message"
                    />
                    <text-element
                        v-if="message.type === $TIM_TYPES.MSG_TEXT"
                        :is-mine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    <image-element
                        v-else-if="message.type === $TIM_TYPES.MSG_IMAGE"
                        :is-mine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    <video-element
                        v-else-if="message.type === $TIM_TYPES.MSG_VIDEO"
                        :is-mine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    <file-element
                        v-else-if="message.type === $TIM_TYPES.MSG_FILE"
                        :is-mine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    <custom-element
                        v-else-if="message.type === $TIM_TYPES.MSG_CUSTOM"
                        :is-mine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    <span v-else>{{$t('暂未支持的消息类型')}}</span>
                </div>
                <message-footer
                    v-if="showMessageHeader"
                    :message="message"
                />
            </div>
            <div class="col-3">
                <!-- 消息状态 -->
            </div>
        </div>

        <div
            v-if="currentConversationType === $TIM_TYPES.CONV_GROUP"
            class="group-layout"
        />
        <div
            v-if="currentConversationType === $TIM_TYPES.CONV_SYSTEM "
            class="system-layout"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Avatar from './Avatar.vue'
import MessageStatusIcon from './MessageStatusIcon.vue'
import TextElement from './elements/TextElement.vue'
import ImageElement from './elements/ImageElement.vue'
import FileElement from './elements/FileElement.vue'
import VideoElement from './elements/VideoElement.vue'
import CustomElement from './elements/CustomElement.vue'
import MessageFooter from './MessageFooter.vue'

// import FaceElement from './message-elements/face-element.vue'
// import SoundElement from './message-elements/sound-element.vue'
// import GroupTipElement from './message-elements/group-tip-element.vue'
// import GroupSystemNoticeElement from './message-elements/group-system-notice-element.vue'
// import CustomElement from './message-elements/custom-element.vue'
// import GeoElement from './message-elements/geo-element.vue'
// import MergerElement from './message-elements/merger-element.vue'

export default {
    name: 'MessageItem',
    components: {
        MessageFooter,
        MessageStatusIcon,
        TextElement,
        Avatar,
        ImageElement,
        FileElement,
        VideoElement,
        CustomElement
    },
    props: {
        message: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            renderDom: []
        }
    },
    computed: {
        ...mapState({
            currentConversation: state => state.timStore.currentConversation,
            currentUserProfile: state => state.timStore.currentUserProfile
        }),
        // 是否显示头像，群提示消息不显示头像
        showAvatar() {
            if (this.currentConversation.type === 'C2C' && !this.message.isRevoked) { // C2C且没有撤回的消息
                return true
            } else if (this.currentConversation.type === 'GROUP' && !this.message.isRevoked) { // group且没有撤回的消息
                return this.message.type !== this.$TIM_TYPES.MSG_GRP_TIP
            }
            return false
        },
        avatar() {
            if (this.currentConversation.type === 'C2C') {
                return this.message.avatar
            } else if (this.currentConversation.type === 'GROUP') {
                return this.isMine ? this.currentUserProfile.avatar : this.message.avatar
            } else {
                return ''
            }
        },
        currentConversationType() {
            return this.currentConversation.type
        },
        isMine() {
            return this.message.flow === 'out'
        },
        messagePosition() {
            if ([ 'TIMGroupTipElem', 'TIMGroupSystemNoticeElem' ].includes(this.message.type)) {
                return 'position-center'
            }
            if (this.message.isRevoked) { // 撤回消息
                return 'position-center'
            }
            if (this.isMine) {
                return 'position-right'
            } else {
                return 'position-left'
            }
        },
        showMessageHeader() {
            if ([ 'TIMGroupTipElem', 'TIMGroupSystemNoticeElem' ].includes(this.message.type)) {
                return false
            }
            if (this.message.isRevoked) { // 撤回消息
                return false
            }
            return true
        }
    },
    methods: {
        showGroupMemberProfile(event) {
            this.$TIM
                .getGroupMemberProfile({
                    groupID: this.message.to,
                    userIDList: [ this.message.from ]
                })
                .then(({ data: { memberList }}) => {
                    if (memberList[0]) {
                        this.$bus.$emit('showMemberProfile', { event, member: memberList[0] })
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.message-wrapper {
  margin: 20px 0;

  .content-wrapper {
    display: flex;
    align-items: center;
  }
}

.group-layout, .c2c-layout, .system-layout {
  display: flex;

  .col-1 {
    .avatar {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
    }
  }

  .group-member-avatar {
    cursor: pointer;
  }

  .col-2 {
    display: flex;
    flex-direction: column;
    // max-width 50% // 此设置可以自适应宽度，目前由bubble限制
  }

  .col-3 {
    width: 30px;
  }

  &.position-left {
    .col-2 {
      align-items: flex-start;
    }
  }

  &.position-right {
    flex-direction: row-reverse;

    .col-2 {
      align-items: flex-end;
    }
  }

  &.position-center {
    justify-content: center;
  }
}

.c2c-layout {
  .col-2 {
    .base {
      margin-top: 3px;
    }
  }
}

.group-layout {
  .col-2 {
    .chat-bubble {
      margin-top: 5px;
      outline: none;
    }
  }
}
</style>
